<template>
  <div>
    <div class="BlockList">
      <div class="BlockList-W">
        <div class="BlockList_Inp"><Homseach></Homseach></div>
        <div class="Blockbox">
          <left @menuHandleClick="dianji"></left>

          <div v-show="names == 'User Transactions'">
            <div class="Blockbox_right">
              <UserTransactions></UserTransactions>
            </div>
          </div>
          <div v-show="names == 'Peak TPS'">
            <div class="Blockbox_right">
              <PeakTPS></PeakTPS>
            </div>
          </div>
          <div v-show="names == 'Transaction signature total'">
            <div class="Blockbox_right">
              <Transactionsignature></Transactionsignature>
            </div>
          </div>
          <div v-show="names == 'Average Gas Unit Price'">
            <div class="Blockbox_right">
              <AverageGas></AverageGas>
            </div>
          </div>
          <div v-show="names == 'Daily Gas Used'">
            <div class="Blockbox_right">
              <DailyGas></DailyGas>
            </div>
          </div>
          <div v-show="names == 'User Bonus & Burned'">
            <div class="Blockbox_right">
              <UserBonus></UserBonus>
            </div>
          </div>
          <div v-show="names == 'TTOS Transaction Volume'">
            <div class="Blockbox_right">
              <Transaction></Transaction>
            </div>
          </div>
          <div v-show="names == 'TTOS Supply & Staking'">
            <div class="Blockbox_right">
              <Supply></Supply>
            </div>
          </div>
          <div v-show="names == 'Total Account & Active Account'">
            <div class="Blockbox_right">
              <Total></Total>
            </div>
          </div>
          <div v-show="names == 'New Accounts Created'">
            <div class="Blockbox_right">
              <New></New>
            </div>
          </div>
          <div v-show="names == 'Daily contract call'">
            <div class="Blockbox_right">
              <Contract></Contract>
            </div>
          </div>
          <div v-show="names == 'Daily Contract Call Distribution'">
            <div class="Blockbox_right">
              <Daily></Daily>
            </div>
          </div>
          <div v-show="names == 'Contract Count'">
            <div class="Blockbox_right">
              <Contractcount></Contractcount>
            </div>
          </div>
          <!-- </div> -->
          <div class="Blockbox_righta">
            <div class="box_right box1" v-show="ind == 0">
              <chartslista></chartslista>
            </div>
          </div>
          <div class="Blockbox_rightb">
            <div class="box_right box2" v-show="ind == 1">
              <chartslistb></chartslistb>
            </div>
          </div>
          <div class="Blockbox_rightc">
            <div class="box_right box3" v-show="ind == 2">
              <chartslistc></chartslistc>
            </div>
          </div>
          <div class="Blockbox_rightd">
            <div class="box_right box4" v-show="ind == 3">
              <chartslistd></chartslistd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Homseach from "@/components/pc/serch.vue";
import left from "./left.vue";
import UserTransactions from "./Blockchan/UserTransactions";
import PeakTPS from "./Blockchan/PeakTPS";
import Transactionsignature from "./Blockchan/Transactionsignature";
import AverageGas from "./Blockchan/AverageGas";
import DailyGas from "./Blockchan/DailyGas";
import Supply from "./TFSC/Supply";
import Transaction from "./TFSC/Transaction";
import UserBonus from "./TFSC/UserBonus";
import New from "./Accounts/New";
import Total from "./Accounts/Total";
import Contract from "./Contracts/Contract";
import Contractcount from "./Contracts/Contractcount";
import Daily from "./Contracts/Daily";
import chartslista from "./charts/chartslista";
import chartslistb from "./charts/chartslistb";
import chartslistc from "./charts/chartslistc";
import chartslistd from "./charts/chartslistd";
import { GetChartData } from "@/assets/server/api";
import { timestampConvertTime1 } from "@/utils/utils.js";
const echarts = require("echarts");
export default {
  data() {
    return {
      ind: 0,
      names: "",
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  watch: {
    // deep: true,
    $route: {
      handler: function (to) {
        console.log(to.query);
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    Homseach,
    left,
    UserTransactions,
    PeakTPS,
    Transactionsignature,
    AverageGas,
    DailyGas,
    Supply,
    Transaction,
    UserBonus,
    New,
    Total,
    Contract,
    Contractcount,
    Daily,
    chartslista,
    chartslistb,
    chartslistc,
    chartslistd,
  },
  mounted() {},
  methods: {
    dianji(payload) {
      console.log(payload);
      this.ind = payload.id;
      this.names = payload;
    },
    menuClose(index) {
      //保留一个菜单总保持打开状态
      if (this.$refs.elMenuRef.openedMenus.length < 1) {
        this.$refs.elMenuRef.open(index);
      }
    },
  },
};
</script>

<style lang="less">
.BlockList {
  width: 100%;
  background: #13161b;
  // border: 1px solid red;
  // height: 1500px;
  .BlockList-W {
    width: 1160px;
    margin: 0 auto;
    padding-bottom: 36px;
    background: #13161b;
    .BlockList_Inp {
      padding: 40px 0;
    }
    .Blockbox {
      display: flex;
      margin-top: 20px;
      .Blockbox_righta,
      .Blockbox_rightb,
      .Blockbox_rightc,
      .Blockbox_rightd {
        //  margin-left: 20px;
        .box_right {
          margin-bottom: 20px;
          width: 872px;
          margin-left: 20px;
          // border: 1px solid yellow;
          //  height: 1104px;
          background: #000000;
          border-radius: 20px 20px 20px 20px;
          opacity: 1;
          padding-bottom: 20px;
        }
      }
      // .Blockbox_rightb {
      //   margin-left: 20px;
      // }
      // .Blockbox_rightc {
      //   margin-left: 20px;
      // }
      // .Blockbox_rightd {
      //   margin-left: 20px;
      // }
      .Blockbox_right {
        margin-left: 20px;
        .box_right {
          margin-bottom: 20px;
          width: 872px;
          border: 1px solid yellow;
          //  height: 1104px;
          // background: #000000;
          border-radius: 20px 20px 20px 20px;
          opacity: 1;
        }
        .box1 {
          height: 1104px;
        }
        .box2 {
          height: 758px;
        }
        .box3 {
          height: 412px;
        }
        .box4 {
          height: 758px;
        }
      }
    }
  }
}
</style>
